<div class="registerCard">
  <h1>Trouble logging in?</h1>
  <h3>
    Please check your email for your password reset instructions, please follow steps outlined in the email to change your password! It may take a few minutes for the email to reach your inbox, check your spam inbox if it does not appear!
  </h3>
</div>
